import { ERR_CANNOT_GET_DATA_FROM_SERVER } from "../../constants"
import { createGenericAuthRequest } from "../request/request-utils"
import { getCachedValue, setCacheValue } from "../utils/cache-util"

const BASE_URL = process.env.REACT_APP_ELEARN_URL || '/'
const BASE_PATH = "/flashcards"
const request = createGenericAuthRequest(BASE_URL)

export async function getAllFlashcards() {
    return request(`${BASE_PATH}`)
}

export async function getAllFlashcardById(id: string) {
    return request(`${BASE_PATH}/${id}`)
}

export async function getAllFlashcardsByCategory(category: string) {
    return request(`${BASE_PATH}/category/${category}`)
}

export async function getAllFlashcardsCached() {
    let cacheKey = `flashcards-all`
    let data = getCachedValue(cacheKey)

    if (!data) {
        try {
            data = await getAllFlashcards()
            setCacheValue(cacheKey, data)
        }
        catch (ex) {
            console.error(ERR_CANNOT_GET_DATA_FROM_SERVER, ex)
        }
    }

    return data
}

async function restGetUserFlashcards() {
    return request(`${BASE_PATH}/activity`)
}

export async function restUpdateFlashcardState(flashcardId: string, status: string, studyTimeInSeconds: number) {
    let payload = { flashcardId, status, studyTimeInSeconds }
    request(`${BASE_PATH}/activity`, payload, {method: "POST"})
}

async function restGetUserFlashcardsCached() {
    let cacheKey = `userflashcards`
    let data = getCachedValue(cacheKey)

    if (!data) {
        try {
            data = await restGetUserFlashcards()
            setCacheValue(cacheKey, data)
        }
        catch (ex) {
            console.error(ERR_CANNOT_GET_DATA_FROM_SERVER, ex)
        }
    }

    return data
}

export async function getUserFlashcards() {
    let flashcards: any[] = await getAllFlashcardsCached()
    let userFlashcards: any[] = await restGetUserFlashcardsCached()

    flashcards.sort((fc1, fc2) => fc1.id.localeCompare(fc2.id))

    flashcards.forEach(f => {
        let found = userFlashcards.find(uf => f.id === uf.flashcardId) 
        if (found) {
            f.status = found.status
        }
        else {
            f.status = "new"
        }
    })

    return flashcards
}

export async function getUserFlashcardsCached() {
    let cacheKey = `flashcards-all-user`
    let data = getCachedValue(cacheKey)

    if (!data) {
        try {
            data = await getUserFlashcards()
            setCacheValue(cacheKey, data)
        }
        catch (ex) {
            console.error(ERR_CANNOT_GET_DATA_FROM_SERVER, ex)
        }
    }

    return data
}

